import { Field, Int } from '@nestjs/graphql'
import { BaseCreateDto } from '../base/baseCreate.dto'
import { ArgsType } from '@nestjs/graphql'

@ArgsType()
export class CreateNotificationDto extends BaseCreateDto<CreateNotificationDto> {
  @Field({ defaultValue: true })
  active: boolean = true

  @Field(t => Int)
  typeFlags!: number

  @Field()
  code!: string

  @Field()
  permissionPreferenceKey!: string

  @Field({ nullable: true })
  templateId?: string

  @Field(t => Date, { nullable: true })
  lastQueuedDate?: Date
}
